export const DATE_FORMAT = 'DD/MM/YYYY';
export const EMPTY_VALUE = '-';
export const CURSOR_POINTER = 'pointer';
export const CURSOR_DEFAULT = '';

export const POPUP_OFFSET = {
  LEFT_CORNER_VERTICAL: 150,
  RIGHT_TOP_CORNER_VERTICAL: 0,
  RIGHT_BOTTOM_CORNER_VERTICAL: -270
} as const;
